import {useMessages} from "i18n";

/**
 * Provider-identification content (kitecorp/transferify-ui#2291). Thin wrapper that renders the
 * active locale's title-free body from the catalog (`messages.legal.impressum`, defined in
 * `src/i18n/richText.*.tsx`), exactly as its four siblings in this directory do. The owning route
 * supplies the single document title.
 *
 * Unlike {@link ./TermsAndConditions} and {@link ./PrivacyPolicy} this body has no dialog surface:
 * the Resources row navigates to `/impressum`, because § 5 DDG asks for identification that is
 * directly accessible and permanently available, and a dialog cannot be linked to or bookmarked.
 */
export default function Impressum() {
	return useMessages().legal.impressum();
}
